import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/Union.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5a171f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "el-card",
  style: {"padding":"20px","height":"100%","box-sizing":"border-box","background-color":"var(--cm-color-card-bg)"}
}
const _hoisted_2 = {
  key: 0,
  class: "animate-pulse",
  style: {"color":"var(--cm-color-text-regular)"}
}
const _hoisted_3 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_4 = { style: {"height":"calc(100% - 68px)","padding":"18px 0","box-sizing":"border-box"} }
const _hoisted_5 = { class: "cm-ui-mb15" }
const _hoisted_6 = { style: {"font-size":"14px"} }
const _hoisted_7 = {
  style: {"line-height":"12px"},
  class: "cm-align-center"
}
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  style: {"font-size":"14px","display":"flex","flex-wrap":"wrap"},
  class: "gap-5"
}
const _hoisted_11 = { class: "cm-ui-mb15" }
const _hoisted_12 = {
  style: {"font-size":"14px","color":"var(--cm-color-text-secondary)"},
  class: "cm-ui-ml10"
}
const _hoisted_13 = {
  style: {"font-size":"14px","color":"var(--cm-color-text-secondary)"},
  class: "cm-ui-ml10"
}
const _hoisted_14 = {
  key: 1,
  class: "gap-y-15",
  style: {"display":"flex","flex-direction":"column","max-height":"400px","height":"auto"}
}
const _hoisted_15 = { style: {"padding":"10px 15px","background":"var(--cm-color-card-bg)"} }
const _hoisted_16 = { style: {"color":"var(--el-color-primary)"} }
const _hoisted_17 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_18 = {
  class: "content gap-x-40",
  style: {"padding":"10px 15px","display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_19 = {
  class: "",
  style: {"flex":"auto"}
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = {
  class: "cm-ui-mt5",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"34px","height":"14px"},
  alt: ""
}, null, -1))
const _hoisted_23 = {
  class: "",
  style: {"flex":"auto"}
}
const _hoisted_24 = { class: "title" }
const _hoisted_25 = {
  class: "cm-ui-mt5",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_26 = {
  key: 1,
  style: {"text-align":"center","margin":"20px 0","font-size":"14px"}
}

import CmForm from '@/components/cmForm/index.vue'
import { FormOpt, FormSize, FormType } from '@/components/cmForm/types'
import CmTable from '@/components/cmTable/index.vue'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ActionState, ActionType, ActionTypes, ApplyState, BtnActionType, PermissionsState, PermissionsText, State } from '../approval/types'
import { ElMessageBox } from 'element-plus'
import { ElMessage } from 'element-plus'
import { useCopy } from '@/utils'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { Apply, AuthParams, AuthSubmitParams, CascadeService, TeamTerminal } from './service'
import { AuthLabel, authMode } from './types'
import { CascadeAppliesData } from '../approval/service'
import { handleDataToTree } from '@/utils/tool'
import { LoginService } from '@/services/login.service'
import { team, user } from '@/common/basis/root-injector'
import { CascadeLoginService } from '@/services/cascade-login.service'
import dayjs from 'dayjs'
import { TableOpt } from '@/components/cmTable/types'
import { errCodeToMsg } from '@/components/cmForm/err-code'
import { RoleService } from '../../_components/roleManage/service'
import { Role_Key } from '../../_components/roleManage/types'
import CascadeSuperiorLinkDialog from '@/views/dashboard/cascade-center/_components/cascade-superior-link-dialog.vue'

type ActionItem = Apply & TeamTerminal & AuthParams

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([CascadeService, LoginService, CascadeLoginService, RoleService])
const cascadeService = injector.get(CascadeService)
const roleService = injector.get(RoleService)
const cascadeLoginService = injector.get(CascadeLoginService)
// 角色列表
const roleListApi = roleService.getRoleList.bind(roleService)
// 生成接入码
const getCascadeAccessCodeApi = cascadeService.getCascadeAccessCode.bind(cascadeService)
// 刷新接入码
const getCascadeRefreshAccessCodeApi = cascadeService.getCascadeRefreshAccessCode.bind(cascadeService)
// 解除级联关系
const getCascadeUnbindApi = cascadeService.getCascadeUnbind.bind(cascadeService)
// 获取申请上级连接信息
const getCascadeSuperiorApplyApi = cascadeService.getCascadeSuperiorApply.bind(cascadeService)
// 级联列表
const getTerminalInfoTeamTerminalListApi = cascadeService.getTerminalInfoTeamTerminalList.bind(cascadeService)
// 获取授权模式信息
const getCascadeTerminalAuthorizeApi = cascadeService.getCascadeTerminalAuthorize.bind(cascadeService)
// 提交授权管理-保存
const getCascadeAuthorizeSaveApi = cascadeService.getCascadeAuthorizeSave.bind(cascadeService)
const tableRef = ref()
const calculateExpiryDate = (days) => {
  const currentDate = new Date();
  const expiryDate = new Date();
  expiryDate.setDate(currentDate.getDate() + days);
  return expiryDate;
}
let defaultFormData = { permissions: [], role_id: '', permission_type: authMode.loneAuth, status: ApplyState.Disconnect, access_code: '', server_host: '', server_port: undefined, child_server_host: window.location.protocol + '//' + window.location.hostname, child_server_port: ~~window.location.port, children_team_id: '', data: [{ order_id: '', children_auth_count: 0 }] } as Partial<CascadeAppliesData & AuthSubmitParams>
const selfList = ref([])
const formColumns = ref({}) as any
const authData = ref([])
const loadingTreeData = ref(false)
const formState = ref(ActionTypes.AccessCode)
const linkConfigVisible = ref(false)
const currentState = ref('4')
const formOpt = ref<FormOpt>({ confirmText: t('cascadeManagePage.applyApproval'), confirmBtnOpt: { disabled: false } })
const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    'tree-props': { children: 'children', hasChildren: 'hasChildren' },
    'default-expand-all': true,
    bodyStyle: 'padding: 0',
    showActionBar: false,
    hiddenPageTool: true,
    showForm: true,
    showRightToolbar: false,
    height: '100%',
    showTip: false,
    rowKey: 'team_id',
    selection: false,
    path: 'datas',
    columns: [
      { label: t('cascadeBranchOverview.colName'), prop: 'name', width: 230 },
      { label: t('cascadeBranchOverview.colIp'), prop: 'child_ip_addr', width: 180 },
      { label: t('cascadeBranchOverview.colPort'), prop: 'child_server_port', width: 120 },
      { label: t('cascadeBranchOverview.colDeployed'), prop: 'terminalInfo', width: 240 },
      { label: t('cascadeBranchOverview.colAuthMode'), prop: 'permission_type', width: 130, formatter: (_row, value) => AuthLabel[value] },
      { label: t('cascadeBranchOverview.colAuthDetail'), prop: 'auth_service_infos', width: 240 },
      { label: t('cascadeBranchOverview.colPermissions'), prop: 'permissions', formatter: (_row, val: string[] = []) => val.length ? val.map(v => PermissionsText[v]) + '' : '--' },
    ],
  }
})
const tableOpt1 = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: 'padding: 0',
    hiddenPageTool: true,
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    showTip: false,
    rowKey: 'id',
    selection: false,
    path: 'data',
    columns: [
      { label: t('cascadeBranchOverview.colName'), prop: 'name', width: 270 },
      { label: t('cascadeManagePage.colAuthCount'), prop: 'auth_count', formatter: (_row, val) => t('cascadeManagePage.terminalsCount', { n: val }) },
      { label: t('cascadeManagePage.remainingDaysCol'), prop: 'expires_days', formatter: (_row, val) => t('cascadeManagePage.daysCount', { n: val }) },
    ],
  }
})
const access_code = ref('')
const formRef = ref()
const preInfo = ref(t('cascadeManagePage.loadingInfo'))
const visible = ref(false)
const loading = ref(false)
const loadingInfo = ref(true)
const disabled = ref(false)
const title = ref('')
const treeData = ref([])
const width = ref<string | number>(500)
const form = ref({ ...defaultFormData })
const tableActOpt = computed(() => {
  void locale.value
  return {
    isLink: true,
    height: '100%',
    columnOpt: { label: t('cascadeBranchOverview.colOperation'), width: 230, align: 'left' },
    actionButtons: ({ permissions = [] }) => [
      { name: t('cascadeManagePage.authManagement'), type: 'authManage', opt: { size: 'large', icon: '', type: 'primary' } },
      {
        name: t('cascadeBranchOverview.login'),
        type: 'login',
        disabledTooltip: permissions.includes(PermissionsState.Password_free_login),
        content: t('cascadeBranchOverview.loginNoPermission'),
        disabled: () => !permissions.includes(PermissionsState.Password_free_login),
        opt: { size: 'medium', icon: '', type: 'primary' },
      },
      { name: t('cascadeBranchOverview.unbind'), type: 'unbind', opt: { size: 'medium', icon: '', type: 'danger' } },
    ],
  }
})
const handleAction = ({ type, rowItem: row }: { type: any, rowItem?: ActionItem }) => {
  const types = {
    viewSecret() {
      formOpt.value = { ...formOpt.value, 'label-position': 'left' }
      formOpt.value.confirmBtnOpt.disabled = false
      visible.value = true
      width.value = 400
      formState.value = ActionTypes.AccessCode
      currentState.value = ActionState.AccessCode
      title.value = t('cascadeManagePage.viewAccessCode')
      formOpt.value.cancelText = ActionType[formState.value][currentState.value].cancelText
      formOpt.value.confirmText = ActionType[formState.value][currentState.value].confirmText
      formColumns.value = {
        viewSecret: {
          label: t('cascadeManagePage.viewAccessCodeField'),
          hiddenAllLabel: true,
          colOpt: { span: 24 },
          slot: true, required: false, formItemOpt: { 'label-width': '0' },
        },
      }
    },
    applyLink() {
      linkConfigVisible.value = true
    },
    authManage() {
      form.value.child_team_id = row.team_id
      form.value.permission_type = row.permission_type || authMode.loneAuth
      getAuthInfo(row)
      visible.value = true
      width.value = '740px'
      formState.value = ActionTypes.Auth
      currentState.value = ActionState.AuthInfo
      formOpt.value.confirmBtnOpt.disabled = false
      title.value = t('cascadeManagePage.authManagement')
      formOpt.value.cancelText = ActionType[formState.value][currentState.value].cancelText
      formOpt.value.confirmText = ActionType[formState.value][currentState.value].confirmText
      formOpt.value = { ...formOpt.value, 'label-position': 'top' }
      const items = {
        [authMode.loneAuth]: {
          colOpt: { span: 24 }, required: false, label: t('cascadeManagePage.authDetail'), slot: true, labelSlot: true
        },
        [authMode.cascadeAuth]: {
          colOpt: { span: 24 }, required: false, label: t('cascadeManagePage.authDetail'), slot: true, labelSlot: true
        }
      }
      formColumns.value = {
        permission_type: { colOpt: { span: 24 }, required: false, label: t('cascadeManagePage.authMode'), radioGroupOpt: { style: 'margin:0;' }, type: FormType.RadioCm, dictData: [{ label: AuthLabel[authMode.loneAuth], value: authMode.loneAuth, subTitle: t('cascadeManagePage.radioSubLone') }, { label: AuthLabel[authMode.cascadeAuth], value: authMode.cascadeAuth, subTitle: t('cascadeManagePage.radioSubCascade') }], events: { change: () => getAuthInfo(row) } },
        authInfo: items[form.value.permission_type]
      }
      formOpt.value.confirmText = t('cascadeManagePage.confirm')
    },
    async unbind(flag?: boolean) {
      await ElMessageBox.confirm(
        flag ? t('cascadeBranchOverview.unbindSuperiorConfirm') : t('cascadeBranchOverview.unbindConfirm'),
        t('cascadeBranchOverview.tip'),
        { confirmButtonText: t('cascadeBranchOverview.confirm'), cancelButtonText: t('cascadeBranchOverview.cancel') }
      )
      const ok = await getCascadeUnbindApi({ cascade_relation_id: flag ? form.value.cascade_relation_id : row?.cascade_relation_id }).catch(err => { })
      ElMessage({ type: ok ? 'success' : 'error', message: ok ? t('cascadeBranchOverview.unbindOk') : t('cascadeBranchOverview.unbindFail') })
      ok && getTerminalInfoTeamTerminalList()
    },
    login() {
      // call授权api
      cascadeLoginService.cascadeLogin({
        ip_addr: row.child_ip_addr,
        server_port: row.child_server_port,
        access_code: row.access_code,
        child_team_id: row.team_id,
        child_team_name: row.name,
        parent_team_id: team.getCurrentTeam().team_id,
        parent_token: user.getUserInfo().token,
      })
    },
    [BtnActionType.Cancel]() {
      visible.value = false
    },
  }
  types[type]()
}
const handleSubmit: (valid: boolean, done: () => void,) => Promise<void> = async (valid: boolean, done: (ok: boolean, message?: string, normalClick?: boolean) => void,) => {
  if (formState.value === ActionTypes.AccessCode) {
    const { access_code: code } = await getCascadeRefreshAccessCodeApi()
    done(true)
    access_code.value = code
  } else if (formState.value === ActionTypes.Auth) {
    if (form.value.permission_type === authMode.loneAuth && authData.value.reduce((p, c) => (p += c.children_auth_count, p), 0)) {
      loading.value = disabled.value = false
      ElMessage({
        type: 'error',
        message: t('cascadeManagePage.revokeChildAuthMessage'),
      })
      return
    }
    const result = await getCascadeAuthorizeSaveApi({ permission_type: form.value.permission_type, children_team_id: form.value.child_team_id, data: authData.value.map(({ order_id, children_auth_count }) => ({ order_id, children_auth_count })) }).catch(err => { })
    const code = result.responseBody?.ret
    const ok = result?.resp_common?.msg === 'ok'
    done(ok,errCodeToMsg[code])
    visible.value = !ok
    ok && getTerminalInfoTeamTerminalList()
  }
}
const getInfo = async () => {
  loadingInfo.value = true
  const { apply = undefined } = await getCascadeSuperiorApplyApi().catch(err => { }) || {}
  loadingInfo.value = false
  if (!apply) return
  form.value = apply
  form.value.role_id ||= role_id.value
}
// 获取数据转换成树型结构
const getTerminalInfoTeamTerminalList = async () => {
  loadingTreeData.value = true
  const { datas } = await getTerminalInfoTeamTerminalListApi().catch(err => { }).finally(() => loadingTreeData.value = false) || []
  treeData.value = handleDataToTree(datas, 'team_id', 'parent_team_id')
}
// 获取授权信息
const getAuthInfo = async (row: TeamTerminal) => {
  const { data = [] } = await getCascadeTerminalAuthorizeApi({ team_id: row.team_id, permission_type: form.value.permission_type }).catch(() => [])
  if (form.value.permission_type === authMode.loneAuth) {
    selfList.value = data.map(item => ({ ...item, total_count: item.auth_count + item.children_auth_count }))
  } else {
    authData.value = data.map(item => ({ ...item, total_count: item.auth_count + item.children_auth_count }))
  }
}
const role_id = ref('')
// 获取角色列表
const getRoleList = async () => {
  const { list = [] } = await roleListApi({ limit: 9999, page: 1 }).catch(err => { }) || {}
  const roleList = list.filter(item => item.role_key !== Role_Key.RoleKeyAdmin)
  role_id.value = roleList.find(item => item.role_key === Role_Key.RoleKeyNormal)?.id
  form.value.role_id = role_id.value
}

function onSuperiorLinkConfigSuccess () {
  preInfo.value = t('cascadeManagePage.updatingInfo')
  getInfo()
  getTerminalInfoTeamTerminalList()
}
onMounted(async () => {
  getTerminalInfoTeamTerminalList()
  const { access_code: code } = await getCascadeAccessCodeApi()
  access_code.value = code
  await getRoleList()
  getInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, { class: "gap-x-20" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 12,
            class: "cm-align-center gap-x-10 el-card cm-ui-pl10",
            style: {"flex":"auto","border-radius":"8px","height":"54px","display":"flex"}
          }, {
            default: _withCtx(() => [
              (loadingInfo.value)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(preInfo.value), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cascadeManagePage.superiorCenterPrefix')) + _toDisplayString(form.value.parent_team_name || '--'), 1),
                    _createVNode(_component_el_tag, {
                      type: _unref(State)[form.value.status].type,
                      effect: "dark",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(State)[form.value.status].title), 1)
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAction({ type: 'applyLink' }))),
                      style: {"padding":"0","min-height":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(form.value?.status !== _unref(ApplyState).Disconnect ? _ctx.$t('cascadeManagePage.editConfig') : _ctx.$t('cascadeManagePage.applyConnection')), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "cm-align-center el-card gap-x-10 cm-ui-pl10",
            style: {"border-radius":"8px","box-sizing":"border-box","height":"54px","display":"flex"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cascadeManagePage.accessCodeTitle')), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('cascadeBranchOverview.accessKeyTooltip')), 1),
              _createTextVNode(),
              _createVNode(_component_el_button, {
                type: "text",
                class: "cm-ui-ml10",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAction({ type: 'viewSecret' }))),
                style: {"padding":"0","min-height":"auto"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.clickToView')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('cascadeBranchOverview.lowerBranches')), 1),
        _withDirectives((_openBlock(), _createBlock(CmTable, {
          tableOpt: tableOpt.value,
          data: treeData.value,
          "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => ((treeData).value = $event)),
          "has-permission": true,
          cardOpt: { style: { height: '100%', border: 'none' } },
          ref_key: "tableRef",
          ref: tableRef,
          pageOption: { pageNumName: 'pageNum', pageSizeName: 'pageSize' },
          tableActOpt: tableActOpt.value,
          modelValue: form.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
          onHandleAction: handleAction,
          firstLoading: false
        }, {
          terminalInfo: _withCtx(({ row }) => [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.terminalLinux')) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: row.linux_num })), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.terminalWindows')) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: row.windows_num })), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.terminalWindowsServer')) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: row.windows_server_num })), 1)
              ])
            ])
          ]),
          "auth_service_infos-header": _withCtx(({label}) => [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(label) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                content: _ctx.$t('cascadeBranchOverview.authDetailTooltip'),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", null, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/cascade-center/cascade-manage/assets/images/info-auth",
                      width: "14",
                      height: "14",
                      class: "cm-ui-ml5",
                      monochrome: ""
                    })
                  ])
                ]),
                _: 1
              }, 8, ["content"])
            ])
          ]),
          auth_service_infos: _withCtx(({ row }) => [
            _createVNode(_component_el_popover, {
              placement: "left",
              trigger: "hover",
              width: 200,
              disabled: row.auth_service_infos.length <= 2
            }, {
              reference: _withCtx(() => [
                (row?.auth_service_infos?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.auth_service_infos.slice(0, 3), (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createTextVNode(_toDisplayString(item.name) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: item.count })), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.auth_service_infos, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: item.count })), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]),
          _: 1
        }, 8, ["tableOpt", "data", "tableActOpt", "modelValue"])), [
          [_directive_loading, loadingTreeData.value]
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((visible).value = $event)),
      title: title.value,
      width: width.value
    }, {
      default: _withCtx(() => [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          modelValue: form.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
          loading: loading.value,
          "onUpdate:loading": _cache[7] || (_cache[7] = ($event: any) => ((loading).value = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[8] || (_cache[8] = ($event: any) => ((disabled).value = $event)),
          actionColOpt: { span: 24, style: 'display:flex;justify-content:flex-end' },
          "global-opt": { required: true },
          formOpt: formOpt.value,
          style: {"display":"flex","flex-direction":"column","justify-content":"space-between","overflow":"hidden","height":"100%"},
          rowOpt: { style: 'overflow:auto;flex:1;', class: 'cm-ui-mb15' },
          ref_key: "formRef",
          ref: formRef,
          formColumns: formColumns.value,
          onReset: _cache[9] || (_cache[9] = ($event: any) => (handleAction({ type: _unref(ActionType)[formState.value][currentState.value].cancelEventType }))),
          onSubmit: handleSubmit
        }, {
          viewSecret: _withCtx(() => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(access_code.value), 1),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(useCopy)(access_code.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cascadeBranchOverview.copyAccessHint')), 1)
              ]),
              _: 1
            })
          ]),
          "authInfo-label": _withCtx(() => [
            (form.value.permission_type === _unref(authMode).loneAuth)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle(_unref(formLabelStyle))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.authDetail')) + " ", 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('cascadeManagePage.authDetailSubLone')), 1)
                ], 4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  style: _normalizeStyle(_unref(formLabelStyle))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.authDetail')) + " ", 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('cascadeManagePage.authDetailSubCascade')), 1)
                ], 4))
          ]),
          authInfo: _withCtx(() => [
            (form.value.permission_type === _unref(authMode).loneAuth)
              ? (_openBlock(), _createBlock(CmTable, {
                  key: 0,
                  data: selfList.value,
                  "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => ((selfList).value = $event)),
                  tableOpt: tableOpt1.value,
                  "has-permission": true
                }, null, 8, ["data", "tableOpt"]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                  (authData.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(authData.value, (i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i.order_id,
                          class: "el-card"
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createTextVNode(_toDisplayString(i.name) + " | ", 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('cascadeManagePage.remainingDays', { days: i.expires_days })), 1),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('cascadeManagePage.dateUntilSuffix', { date: _unref(dayjs)(calculateExpiryDate(i.expires_days)).format('YYYY-MM-DD') })), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('cascadeManagePage.levelAvailableAuth')), 1),
                              _createElementVNode("div", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.maxGrantQuota')) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('cascadeManagePage.terminalsCount', { n: i.total_count - i.children_auth_count })), 1)
                              ])
                            ]),
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('cascadeManagePage.childAuthDetailTitle')), 1),
                              _createElementVNode("div", _hoisted_25, [
                                _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.grantedQuota')) + " ", 1),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_el_input_number, {
                                    min: 0,
                                    max: i.total_count,
                                    modelValue: i.children_auth_count,
                                    "onUpdate:modelValue": ($event: any) => ((i.children_auth_count) = $event),
                                    style: {"flex":"none"},
                                    size: "mini",
                                    class: "cm-ui-mr10"
                                  }, null, 8, ["max", "modelValue", "onUpdate:modelValue"]),
                                  _createTextVNode(_toDisplayString(_ctx.$t('cascadeManagePage.terminalSuffix')), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("li", _hoisted_26, _toDisplayString(_ctx.$t('cascadeManagePage.noListData')), 1))
                ]))
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "loading", "disabled", "formOpt", "formColumns"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "width"]),
    _createVNode(CascadeSuperiorLinkDialog, {
      modelValue: linkConfigVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((linkConfigVisible).value = $event)),
      onSuccess: onSuperiorLinkConfigSuccess
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})